import RestClient from './rest-client'

export default class Session extends RestClient {
  static get url () {
    return this.apiUrl
  }

  static async login (credentials) {
    const { data } = await this._post(this.url + '/sign_in', credentials)

    return data
  }

  static async logout () {
    const { data } = await this._delete(this.url + '/sign_out')

    return data
  }

  static async sendResetPassword (email) {
    const { data } = await this._post(this.url + '/forgot_password', {
      user: { email }
    })

    return data
  }

  static async resetPassword (params = {}) {
    const { data } = await this._put(this.url + '/reset_password', {
      user: params
    })

    return data
  }

  static async sendConfirmationEmail (email) {
    const { data } = await this._post(this.url + '/confirmations', {
      user: { email }
    })

    return data
  }

  static async confirmEmail (confirmationToken) {
    const { data } = await this._get(this.url + '/confirmations', {
      confirmation_token: confirmationToken
    })

    return data
  }
}
